"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.JsonUtils = void 0;
var js_utils_1 = require("./js-utils");
var __1 = require("..");
/**
 * @author arnozhang
 * @date 2019/06/25
 */
var TAG = 'JsonUtils';
var JsonUtils = /** @class */ (function () {
    function JsonUtils() {
    }
    JsonUtils.parseObjectSafe = function (content, defObject) {
        try {
            var result = JSON.parse(content);
            if (js_utils_1.JsUtils.isObject(result)) {
                return result;
            }
        }
        catch (e) {
            __1.Logger.e(TAG, "parseObjectSafe error: " + e);
        }
        return defObject;
    };
    JsonUtils.parseArraySafe = function (content, defArray) {
        try {
            var result = JSON.parse(content);
            if (js_utils_1.JsUtils.isArray(result)) {
                return result;
            }
        }
        catch (e) {
            __1.Logger.e(TAG, "parseArraySafe error: " + e);
        }
        return defArray;
    };
    JsonUtils.toJsonString = function (value, pretty) {
        if (pretty == true) {
            return JSON.stringify(value, null, 2);
        }
        return JSON.stringify(value);
    };
    JsonUtils.removeUndefinedFields = function (value) {
        if (js_utils_1.JsUtils.isObject(value)) {
            for (var _i = 0, _a = Object.keys(value); _i < _a.length; _i++) {
                var name_1 = _a[_i];
                var item = value[name_1];
                if (item == null || item == undefined) {
                    delete value[name_1];
                }
                else {
                    JsonUtils.removeUndefinedFields(item);
                }
            }
        }
    };
    JsonUtils.prettyJsonString = function (value, indent, error) {
        try {
            if (js_utils_1.JsUtils.isString(value)) {
                value = JSON.parse(value);
            }
            return JSON.stringify(value, null, indent != null ? indent : 2);
        }
        catch (e) {
            if (error) {
                error("" + e);
            }
        }
        return null;
    };
    return JsonUtils;
}());
exports.JsonUtils = JsonUtils;
